<div class="list-counter">
  <span *ngIf="total">{{ 'actions.numElements' | translate }}: {{ total }}</span>
</div>
